import { Component, Input, input } from '@angular/core';

@Component({
  selector: 'app-common-area-prop-container',
  templateUrl: './common-area-prop-container.component.html',
  styleUrl: './common-area-prop-container.component.scss',
  standalone: false
})
export class CommonAreaPropContainerComponent {
  @Input({ required: true }) isActive!: boolean;
  @Input({ required: true }) iconOn!: string;
  @Input({ required: true }) iconOff!: string;
  @Input({ required: true }) labelOn!: string;
  @Input({ required: true }) labelOff!: string;
  @Input() titleOn: string = '';
  @Input() titleOff: string = '';

}
